{
    "request": {
        "reminder_sent": {
            "title": "Reminded",
            "message": "A reminder was sent out."
        },
        "reminder_not_sent": {
            "title": "Reminder not sent",
            "message": "Could not send the reminder."
        },
        "cancelled": {
            "title": "Removed",
            "message": "Request has been removed."
        },
        "approved": {
            "title": "Approved",
            "message": "Request has been approved."
        },
        "reviewed": {
            "title": "Reviewed",
            "message": "Request has been reviewed."
        },
        "reviewed_bulk": {
            "title": "Reviewed",
            "message": "Requests have been reviewed."
        },
        "reviewed_bulk_partial": {
            "title": "Partially reviewed",
            "message": "Requests have been partially reviewed. Following requests could not be successfully reviewed: {{expenses}}."
        },
        "paid": {
            "title": "Paid",
            "message": "Request has been paid."
        },
        "paid_bulk": {
            "title": "Paid",
            "message": "Requests have been paid."
        },
        "paid_bulk_partial": {
            "title": "Partially paid",
            "message": "Requests have been partially paid. Following requests could not be successfully paid: {{expenses}}."
        },
        "exported": {
            "title": "Exported",
            "message": "Request has been exported."
        },
        "exported_bulk": {
            "title": "Exported",
            "message": "Requests have been exported."
        },
        "exported_bulk_partial": {
            "title": "Partially exported",
            "message": "Requests have been partially exported. Following requests could not be successfully exported: {{expenses}}."
        },
        "async_export_started": {
            "title": "Large export started",
            "message": "Once the export is completed the file will automatically be downloaded in the background. You can also use the export history to download it."
        },
        "async_export_started_partial": {
            "title": "Large export partially started.",
            "message": "Once the export is completed the file will automatically be downloaded in the background. You can also use the export history to download it. Following requests could not be successfully exported: {{expenses}}."
        },
        "async_duo_export_started_partial": {
            "title": "DUO export partially started",
            "message": "The export to DUO was started in the background. Following requests were filtered out since they are not compatible to DATEV: {{expenses}}."
        },
        "async_duo_export_started": {
            "title": "DUO export started",
            "message": "The export to DUO was started in the background."
        },
        "async_export_failed": {
            "title": "Export fehlgeschlagen"
        },
        "datev_job_status_manual_check": {
            "title": "Info",
            "message": "Updated DATEV Online export status."
        },
        "rejected": {
            "title": "Rejected",
            "message": "Request has been rejected.",
            "link": "View request"
        },
        "changes_requested": {
            "title": "Changes requested",
            "message": "Changes have been requested successfully.",
            "link": "View request"
        },
        "created": {
            "title": "Created",
            "message": "Request has been created.",
            "link": "View request"
        },
        "created_with_card_processing": {
            "title": "Created",
            "message": "Request has been created. The corresponding card is being issued. This might take a minute."
        },
        "updated": {
            "title": "Updated",
            "message": "Request has been updated."
        },
        "tax": {
            "title": "Updated",
            "message": "Tax has been updated."
        },
        "already_deleted": {
            "title": "Warning - This request has been deleted.",
            "message": "It is readonly and only shown for backwards dependencies."
        },
        "paused_info": {
            "title": "Info - This subscription is currently paused.",
            "message": "No recurring expenses will be auto-generated for paused subscriptions."
        },
        "paused": {
            "title": "Paused",
            "message": "Subscription is paused."
        },
        "unpaused": {
            "title": "Reactivated",
            "message": "Subscription is reactivated."
        },
        "reset": {
            "title": "Updated",
            "message": "Request status has been reset."
        },
        "restored": {
            "title": "Restored",
            "message": "Request has been restored"
        },
        "archived": {
            "title": "Archived",
            "message": "Request has been archived"
        },
        "unarchived": {
            "title": "Unarchived",
            "message": "Request has been unarchived"
        },
        "opos_excluded": {
            "title": "Item cleared",
            "message": "Item has been cleared from the open items list."
        },
        "opos_included": {
            "title": "Item retrieved",
            "message": "The item has been included again in the open items list."
        },
        "opos_included_bulk": {
            "title": "Items retrieved",
            "message": "The items have been included again in the open items list."
        },
        "follow_up_set": {
            "title": "Follow-up set",
            "message": "Your follow-up was successfully set for {{date}}"
        },
        "detached": {
            "title": "Detached",
            "message": "Request has been detached from the folder."
        },
        "attached": {
            "title": "Attached",
            "message": "Request has been attached to the folder {{folderName}}."
        },
        "delete": {
            "title": "Request deleted",
            "message": "Request #{{expenseNumber}} has been deleted."
        },
        "marked_as_done": {
            "title": "Marked as done",
            "message": "Request has been marked as done."
        },
        "sync_expense_creditor": {
            "title": "Synchronization successful",
            "message": "The request was successfully updated with the latest creditor data."
        }
    },
    "per_diem": {
        "destination_break_off": {
            "title": "New destinations for per diem rates in {{year}}",
            "message": "{{destination}} will no longer be supported as a separate destination in {{year}}. Therefore, the date and destination will be updated automatically. Please check the information carefully."
        },
        "missing_destination_for_date_range": "Missing destination for date range"
    },
    "bug_report": {
        "title": "Success",
        "message": "Feedback has been sent."
    },
    "file": {
        "uploaded": {
            "title": "File(s) uploaded",
            "message": "File(s) has been uploaded."
        },
        "deleted": {
            "title": "File deleted",
            "message": "File has been deleted."
        }
    },
    "invoice_inbox": {
        "expense_attached": {
            "title": "Success",
            "message": "Invoice in inbox has been attached to expense."
        },
        "deleted": {
            "title": "Success",
            "message": "Invoice successfully deleted."
        },
        "auto_matched": {
            "title": "Info",
            "message": "Invoice \"{{fileName}}\" from the inbox was automatically matched to request #{{expenseNumber}}."
        },
        "move": {
            "title": "Success",
            "message": "The invoice {{name}} was successfully moved to {{company}}."
        },
        "assign": {
            "title": "Success",
            "message": "The document {{name}} was successfully assigned to {{employee}}."
        },
        "unassign": {
            "title": "Success",
            "message": "The employee {{employee}} was successfully unassigned from document {{name}}."
        },
        "change_document_type": {
            "title": "Success",
            "message": "The document type for {{name}} was changed to {{documentType}} and OCR was restarted."
        }
    },
    "comment": {
        "saved": {
            "title": "Success",
            "message": "Comment saved."
        },
        "updated": {
            "title": "Success",
            "message": "Comment updated."
        },
        "deleted": {
            "title": "Success",
            "message": "Comment deleted."
        }
    },
    "subscription": {
        "deleted": {
            "title": "Success",
            "message": "Subscription has been deleted."
        },
        "already_deleted": {
            "title": "Warning - This subscription has been deleted.",
            "message": "It is readonly and only shown for backwards dependencies."
        },
        "card_invalid": {
            "title": "Action required – The payment card for this subscription is no longer valid.",
            "message": "Please remove the current payment card and add a new one to avoid any interruption to your subscription.",
            "removed": {
                "title": "Success",
                "message": "The payment card has been removed from this subscription."
            }
        }
    },
    "transaction": {
        "deleted": {
            "title": "Success",
            "message": "Transaction has been deleted."
        },
        "bulk_deleted": {
            "title": "Success",
            "message": "Transactions have been deleted."
        },
        "update_category": {
            "title": "Success",
            "message": "Transactions category has been updated."
        }
    },
    "vendor": {
        "created": {
            "title": "Created",
            "message": "Vendor has been created."
        },
        "updated": {
            "title": "Updated",
            "message": "Vendor has been updated."
        },
        "deleted": {
            "title": "Deleted",
            "message": "Vendor has been deleted."
        },
        "restored": {
            "title": "Restored",
            "message": "Vendor has been restored."
        },
        "already_deleted": {
            "title": "Warning - This vendor has been deleted.",
            "message": "It is readonly and only shown for backwards dependencies."
        },
        "approved": {
            "title": "Approved",
            "message": "Vendor has been approved."
        },
        "rejected": {
            "title": "Rejected",
            "message": "Vendor has been rejected."
        },
        "exported_bulk": {
            "title": "Exported",
            "message": "Vendors have been exported."
        }
    },
    "employee": {
        "created": {
            "title": "Created",
            "message": "Employee has been created."
        },
        "updated": {
            "title": "Updated",
            "message": "Employee has been updated."
        },
        "email_updated": {
            "title": "Email verification required",
            "message": "Please confirm your new email address with the link we have sent you."
        },
        "deleted": {
            "title": "Deleted",
            "message": "Employee has been deleted"
        },
        "restored": {
            "title": "Restored",
            "message": "Employee has been restored"
        },
        "already_deleted": {
            "title": "Warning - This employee has been deleted.",
            "message": "It is readonly and only shown for backwards dependencies."
        },
        "invite": {
            "title": "Employee Invitation",
            "message": "Employee invited to company"
        },
        "email_alias_updated": {
            "title": "Success",
            "message": "Successfully set email alias."
        },
        "absence_updated": {
            "title": "Success",
            "message": "Absence was successfully set up"
        },
        "absence_removed": {
            "title": "Success",
            "message": "Absence has been removed"
        },
        "reset_tfa": {
            "title": "Reset",
            "message": "2FA was reset for this employee."
        }
    },
    "company_profile": {
        "created": {
            "title": "Created",
            "message": "Company profile for employee has been created."
        },
        "updated": {
            "title": "Updated",
            "message": "Company profile for employee has been updated."
        },
        "deleted": {
            "title": "Deleted",
            "message": "Company profile for employee has been deleted"
        },
        "restored": {
            "title": "Restored",
            "message": "Company profile for employee has been restored"
        }
    },
    "cost_center": {
        "created": {
            "title": "Created",
            "message": "Cost center 1 has been created."
        },
        "updated": {
            "title": "Updated",
            "message": "Cost center 1 has been updated."
        },
        "deleted": {
            "title": "Deleted",
            "message": "Cost center 1 has been deleted"
        },
        "restored": {
            "title": "Restored",
            "message": "Cost center 1 has been restored"
        },
        "already_deleted": {
            "title": "Warning - This cost center 1 has been deleted.",
            "message": "It is readonly and only shown for backwards dependencies."
        },
        "exported_bulk": {
            "title": "Exported",
            "message": "Cost centers have been exported."
        }
    },
    "settings": {
        "user_profile": {
            "updated": {
                "title": "Success",
                "message": "Profile has been successfully updated."
            }
        },
        "password": {
            "updated": {
                "title": "Success",
                "message": "Password has been successfully changed."
            }
        },
        "expense_account": {
            "updated": {
                "title": "Success",
                "message": "1 Expense account has been successfully updated.",
                "message_other": "{{count}} Expense accounts have been successfully updated."
            },
            "deleted": {
                "title": "Success",
                "message": "1 Expense account has been successfully deleted.",
                "message_other": "{{count}} Expense accounts have been successfully deleted."
            },
            "saved": {
                "title": "Success",
                "message": "1 Expense account has been successfully added.",
                "message_other": "{{count}} Expense accounts have been successfully added."
            }
        },
        "cost_center_2": {
            "updated": {
                "title": "Success",
                "message": "1 Cost center 2 has been successfully updated.",
                "message_other": "{{count}} Cost centers 2 have been successfully updated."
            },
            "deleted": {
                "title": "Success",
                "message": "1 Cost center 2 has been successfully deleted.",
                "message_other": "{{count}} Cost centers 2 have been successfully deleted."
            },
            "saved": {
                "title": "Success",
                "message": "1 Cost center 2 has been successfully added.",
                "message_other": "{{count}} Cost centers 2 have been successfully added."
            },
            "created": {
                "title": "Created",
                "message": "Cost center 2 has been created."
            }
        },
        "tools": {
            "updated": {
                "title": "Success",
                "message": "Tool settings have been successfully updated."
            }
        },
        "company": {
            "updated": {
                "title": "Success",
                "message": "Company settings have been successfully updated."
            },
            "connected_datev": {
                "title": "Success",
                "message": "DUO was successfully connected."
            },
            "connect_datev": {
                "title": "Info",
                "message": "Please finish the DUO authentication process by filling out the popped up form."
            },
            "disconnected_datev": {
                "title": "Warning",
                "message": "DUO was successfully disconnected."
            },
            "aborted_datev_setup": {
                "title": "Warning",
                "message": "DUO setup was aborted."
            },
            "custom_bank_subject_updated": {
                "title": "Success",
                "message": "Custom bank subject line was updated."
            },
            "datev_info": {
                "title": "Success",
                "message": "Datev Information was updated."
            },
            "datev_csv_config_info": {
                "title": "Success",
                "message": "Accounts for DATEV CSV wallet & account length information was updated."
            },
            "datev_client_and_consultant_info": {
                "title": "Success",
                "message": "DATEV client and consultant information was updated."
            },
            "debit_card_limit_buffer_updated": {
                "title": "Success",
                "message": "Debit card limit buffer was updated."
            },
            "fallback_approver": {
                "updated": {
                    "title": "Success",
                    "message": "Fallback approver successfully updated."
                }
            },
            "email_forwarding_address": {
                "copied": {
                    "title": "Success",
                    "message_1": "Email forwarding address \"",
                    "message_2": "\" copied to your clipboard. You can forward your invoices to that address to import them automatically to your finway inbox."
                }
            },
            "fiscal_year": {
                "title": "Success",
                "message": "Fiscal year has been successfully updated. "
            }
        },
        "csv_template": {
            "saved": {
                "title": "Success",
                "message": "CSV Template has been successfully saved"
            },
            "deleted": {
                "title": "Success",
                "message": "CSV Template has been successfully deleted"
            }
        },
        "tax": {
            "updated": {
                "title": "Success",
                "message": "VATs successfully updated."
            }
        },
        "team": {
            "updated": {
                "title": "Success",
                "message": "Teams successfully updated."
            }
        },
        "troubleshooting": {
            "cleared": {
                "title": "Success",
                "message": "Cache and cookies have been successfully cleared. Please login again to continue using finway."
            }
        },
        "role": {
            "created": {
                "title": "Success",
                "message": "Role successfully created."
            },
            "updated": {
                "title": "Success",
                "message": "Role successfully updated."
            }
        }
    },
    "payment_subscription": {
        "created": {
            "title": "Success",
            "message": "A payment subscription has been created."
        },
        "updated": {
            "title": "Success",
            "message": "Your payment subscription has been updated."
        },
        "cancelled": {
            "title": "Success",
            "message": "Your payment subscription has been cancelled."
        },
        "reactivated": {
            "title": "Success",
            "message": "Your payment subscription has been reactivated."
        },
        "inv_download": {
            "title": "Success",
            "message": "Your latest invoice was downloaded."
        },
        "deleted": {
            "title": "Success",
            "message": "Your payment subscription data was deleted."
        }
    },
    "rejection_note": {
        "title": "Rejection explanation",
        "message": "Please tell us why you are rejecting this request",
        "confirm": "Reject",
        "cancel": "Cancel"
    },
    "request_changes": {
        "title": "Warning",
        "message": "If you request changes on this request, the approval process will be reset, and all approvals done on it will be lost. Would you like to continue?",
        "confirm": "Yes",
        "cancel": "No"
    },
    "password_reset": {
        "title": "Password reset",
        "message": "Your password has been successfully reset."
    },
    "password_set": {
        "title": "Password set",
        "message": "Your new password was set."
    },
    "password_forgot": {
        "title": "Recovery started",
        "message": "If an account for this email address exists, a password recovery was sent."
    },
    "set_new_password_request": {
        "title": "Check your email inbox",
        "message": "You can set a new password now, please check your email inbox."
    },
    "new_api_version": {
        "title": "New Version rolled out",
        "message": "A new version has been rolled out. Please log in again."
    },
    "matching": {
        "csv_upload": {
            "title": "Success",
            "message": "CSV file has been processed."
        },
        "csv_upload_info": {
            "title": "Please make sure your CSV contains the following mandatory information",
            "field_1": "Amount",
            "field_2": "Date (of transaction)",
            "field_3": "Currency - Please use the 3-letter ISO currency codes (e.g., EUR for Euro)"
        },
        "csv_currency_info": {
            "message": "If your CSV has no currency column, please add a “Currency” column (use 3-letter ISO codes like EUR). Or  pick a default currency here. If both are set, the CSV’s currency values will be used."
        },
        "bank": {
            "title": "Info",
            "message": "Bank transactions are being imported and matched. This can take a couple minutes."
        },
        "title": "Success",
        "message": "Matching has been performed.",
        "matched": {
            "title": "Success",
            "message": "Transaction was successfully matched."
        },
        "unmatched": {
            "title": "Success",
            "message": "Transaction was successfully unmatched."
        },
        "need_consent": {
            "title": "Info",
            "message": "Please complete the web-form opened in the new tab to give consent to fetch your newest transactions. Then please retry to fetch the bank transactions."
        },
        "hasArchivedTransactions": {
            "title": "Warning",
            "message": "Uploaded transactions have been automatically archived because of the archive settings."
        }
    },
    "banking": {
        "import_started": {
            "title": "Info",
            "message": "Bank import process started. Please finish the web-form."
        },
        "imported": {
            "title": "Success",
            "message": "Bank successfully imported. Transactions are being downloaded."
        },
        "deleted": {
            "title": "Success",
            "message": "Bank account deleted."
        },
        "update_started": {
            "title": "Info",
            "message": "Bank connection update process started. Please finish the web-form."
        },
        "updated": {
            "title": "Success",
            "message": "Bank account updated."
        },
        "payment_started": {
            "title": "Info",
            "message": "Payment process started. Please finish the web-form."
        },
        "paid": {
            "title": "Success",
            "message": "Payment successfully issued."
        },
        "new_interface_add_started": {
            "title": "Info",
            "message": "Connecting new interface process started. Please finish the web-form.'"
        },
        "new_interface_added": {
            "title": "Success",
            "message": "Additional interface successfully added. New transactions are being downloaded."
        },
        "account": {
            "deleted": {
                "title": "Success",
                "message": "Bank account deleted."
            }
        },
        "downloaded": {
            "title": "Success",
            "message": "Finished downloading all transactions."
        },
        "refresh_payment_status": {
            "title": "Success",
            "message": "Payment status is successfully updated."
        },
        "amounts_mismatch": {
            "title": "Warning SEPA-XML Export",
            "message": "The sum of the NET, TAX and GROSS values is not consistent."
        },
        "webformurl": {
            "link": "Banking login"
        }
    },
    "expense_filter": {
        "updated": {
            "title": "Success",
            "message": "Expense filter updated."
        }
    },
    "ocr": {
        "processed": {
            "title": "Success",
            "message": "OCR has been processed and the form has been updated."
        },
        "processed_and_updated": {
            "title": "Success",
            "message": "OCR has been processed and the expense has been updated."
        }
    },
    "cards": {
        "kyb": {
            "submit": {
                "title": "Success",
                "message": "Your business data has been successfully submitted and is now being reviewed."
            }
        },
        "set_pin": {
            "title": "Success",
            "message": "Finway PIN has been set."
        },
        "top_up": {
            "title": "Success",
            "message": "Card has been topped up."
        },
        "empty": {
            "title": "Success",
            "message": "Card has been emptied."
        },
        "pin_request": "Request PIN to activate your card.",
        "activation_request": "Enter verification code to activate your card.",
        "click": "Click",
        "pin_link": "here to activate",
        "pin_resend_email": "here to resend the verification code email",
        "status": {
            "resumed": {
                "title": "Success",
                "message": "Card successfully resumed."
            },
            "suspend": {
                "title": "Warning",
                "message": "Card successfully suspended."
            },
            "close": {
                "title": "Warning",
                "message": "Card successfully closed."
            },
            "report_stolen": {
                "title": "Warning",
                "message": "Card reported as stolen."
            },
            "report_lost": {
                "title": "Warning",
                "message": "Card reported as lost."
            }
        },
        "created": {
            "title": "Success",
            "message": "Card was issued."
        },
        "updated": {
            "title": "Success",
            "message": "Card settings have been updated."
        },
        "phone_number_updated": {
            "title": "Success",
            "message": "Card phone number have been updated."
        },
        "fix_card": {
            "title": "Success",
            "message": "Card successfully fixed."
        },
        "expense_card_creation": {
            "title": "Success",
            "message": "Expense card was issued."
        },
        "activated": {
            "title": "Success",
            "message": "Card was activated."
        },
        "verification_email_resent": {
            "title": "Success",
            "message": "Email with verification code was sent."
        },
        "all_enrolled": {
            "title": "Success",
            "message": "All users enrolled."
        },
        "limit_change_request": {
            "title": "Success",
            "message": "Limit change requested successfully."
        },
        "not_all_enrolled": {
            "title": "Warning",
            "message": "Not all users could be enrolled."
        },
        "no_access": {
            "title": "Error",
            "message": "You don't have access to this card."
        },
        "account_statement_regenerating": {
            "title": "Info",
            "message": "Account statement is being regenerated. This can take a couple minutes."
        },
        "pin_unblocked": {
            "title": "Success",
            "message": "PIN successfully unblocked."
        },
        "card_program_auth_success": {
            "title": "Success",
            "message": "Successfully authenticated."
        }
    },
    "reports": {
        "no_data": "No report data",
        "refresh_started": {
            "title": "Reporting data refresh",
            "message": "Refreshing data. Please wait a moment."
        },
        "refresh_forbidden": {
            "title": "Reporting data refresh",
            "message": "Refresh only allowed every {{time1}} min. Please try again in {{time2}} min."
        }
    },
    "corporate": {
        "setup_user_passcode": {
            "title": "Success",
            "message": "Finway PIN successfully created."
        },
        "verify_email": {
            "title": "Success",
            "message": "Email successfully verified."
        },
        "email_verification_code": {
            "title": "Success",
            "message": "Email verification code sent."
        },
        "verify_mobile": {
            "title": "Success",
            "message": "Mobile successfully verified."
        },
        "mobile_verification_code": {
            "title": "Success",
            "message": "Mobile verification code sent."
        },
        "mobile_already_verified": {
            "title": "Success",
            "message": "This mobile number is already verified."
        },
        "enroll_user": {
            "title": "Success",
            "message": "User was successfully enrolled to cards program."
        },
        "account_created": {
            "title": "Success",
            "message": "Business account successfully created."
        },
        "company_details_submitted": {
            "title": "Success",
            "message": "Company details successfully submitted."
        }
    },
    "wallet": {
        "wire_sent": {
            "title": "Success",
            "message": "Transfer successfully started."
        },
        "auth_factor_enroll_success": {
            "title": "Success",
            "message": "Device successfully enrolled."
        },
        "iban_created": {
            "title": "Success",
            "message": "Wallet successfully created."
        }
    },
    "passcode": {
        "recovery_success": {
            "title": "Success",
            "message": "Finway PIN recovered successfully"
        },
        "update_success": {
            "title": "Success",
            "message": "Finway PIN updated successfully."
        }
    },
    "socket": {
        "connection_lost": "Connection to the server is lost",
        "reconnecting": "Reconnecting ...",
        "connection_state": "Server connection state",
        "connected": "Connected",
        "retry": "Retry",
        "reload": "Reload"
    },
    "workflow": {
        "deleted": {
            "title": "Warning",
            "message": "Workflow was successfully deleted."
        },
        "created": {
            "title": "Success",
            "message": "Workflow was successfully created."
        },
        "updated": {
            "title": "Success",
            "message": "Workflow was successfully updated."
        }
    },
    "liquidity": {
        "add_scenario": {
            "title": "Success",
            "message": "New scenario was successfully added."
        },
        "update_scenario": {
            "title": "Success",
            "message": "Scenario was successfully updated."
        },
        "deleted_scenario": {
            "title": "Success",
            "message": "Scenario has been deleted."
        },
        "add_forecast_rule": {
            "title": "Success",
            "message": "New forecast rule was successfully added."
        },
        "update_forecast_rule": {
            "title": "Success",
            "message": "Forecast rule was successfully updated."
        },
        "delete_forecast_rule": {
            "title": "Success",
            "message": "Forecast rule has been deleted."
        }
    },
    "integrations": {
        "get_my_invoices": {
            "title": "Success",
            "message": "GetMyInvoices integration successfully updated."
        },
        "personio": {
            "title": "Success",
            "info": "Info",
            "infoText": "The data synchronization started but might take some time.",
            "message": "Personio integration successfully updated."
        }
    },
    "transaction_category": {
        "created": {
            "title": "Success",
            "message": "Category successfully added."
        },
        "updated": {
            "title": "Success",
            "message": "Category successfully updated."
        },
        "deleted": {
            "title": "Success",
            "message": "Category successfully deleted."
        }
    },
    "payment_method": {
        "updated": {
            "title": "Success",
            "message": "Payment method successfully updated."
        }
    },
    "payment_settings": {
        "sign_up_banner": {
            "title": "Please add your payment data",
            "message": "We are currently automating the subscription and billing process of your finway subscription. Please enter your payment data (card or SEPA direct debit) in the settings. You thereby agree to be charged automatically for your finway subscription."
        },
        "automatic_billing": {
            "title": "Automatic billing",
            "message1": "Save time and nerves by switching to automatic billing. Simply enter your payment data to activate your product.",
            "message2": "You thereby agree to be charged automatically for your finway subscription."
        }
    },
    "session_expired": {
        "title": "Warning",
        "message": "Your session expired and you were logged out for security reasons."
    },
    "import_result": {
        "validate_only": {
            "title": "Validation completed",
            "message": "Data validation has been completed. Check the results by clicking on the button below."
        },
        "validation_errors": {
            "title:": "Data import aborted",
            "message": "Data import aborted because validation errors were found. Please resolve them and try again."
        },
        "success": {
            "title": "Success",
            "message": "Data imported successfuly. Check the results by clicking on the button below."
        }
    },
    "mass_export": {
        "started": {
            "message": "Export started",
            "description": "Once the export is completed you will be notified"
        }
    },
    "trip_folder": {
        "date_error": "Your trip has exceeded the 3 month period. Please reach out to your finance team, since regular per diem reimbursements do not apply in this case",
        "cancelled": {
            "title": "Removed",
            "message": "Trip folder has been removed."
        },
        "submitted": {
            "title": "Submitted",
            "message": "Trip folder has been submitted"
        },
        "deleted": {
            "title": "Trip folder deleted",
            "message": "Trip folder #{{expenseNumber}} has been deleted."
        },
        "archived": {
            "title": "Archived",
            "message": "Trip folder has been archived."
        },
        "unarchived": {
            "title": "Unarchived",
            "message": "Trip folder has been unarchived."
        },
        "created": {
            "title": "Created",
            "message": "Trip folder has been created.",
            "link": "View trip folder"
        },
        "rejected": {
            "title": "Rejected",
            "message": "Trip folder has been rejected.",
            "link": "View trip folder"
        },
        "marked_as_done": {
            "title": "Marked as done",
            "message": "Trip folder has been marked as done."
        },
        "exported": {
            "title": "Exported",
            "message": "Trip folder has been exported."
        },
        "exported_bulk": {
            "title": "Exported",
            "message": "Trip folders have been exported."
        }
    },
    "mfa": {
        "reset_for_user": {
            "title": "MFA reset",
            "message": "MFA is reset for {{employee_name}}"
        }
    },
    "new_version": {
        "title": "New finway version available",
        "message": "Page will reload in {{time}} sec."
    },
    "async_export_started": {
        "title": "Large export started",
        "message": "Once the export is completed the file will automatically be downloaded in the background. You can also use the export history to download it."
    },
    "user_password_reset": {
        "title": "Success",
        "message": "Password successfully reset."
    },
    "password": {
        "changed": {
            "title": "Success",
            "message": "Password changed"
        }
    },
    "change_history_export": {
        "start": {
            "title": "Large export started",
            "message": "Once the export is completed the file will automatically be downloaded in the background. You can also use the export history to download it."
        },
        "finish": {
            "message": "The change history has been exported.",
            "title": "Exported"
        }
    },
    "datev_invoice_csv": {
        "title": "Attention - export incomplete",
        "message": "The \"Gegenkonto\" column might have some empty cells, check the export settings. If necessary, also add the client and consultant number."
    },
    "data_demo_is_being_created": {
        "title": "Success",
        "message": "New demo data will be created. This can take a moment, sit back and let the magic happen."
    },
    "employee_absence": {
        "substitute_updated": {
            "title": "Success",
            "message": "Absence replacement was successfully updated."
        }
    },
    "purchase_order": {
        "already_deleted": {
            "title": "Warning - This Purchase Order has been deleted.",
            "message": "It is readonly and only shown for backwards dependencies."
        },
        "approved": {
            "title": "Approved",
            "message": "Purchase order has been approved."
        },
        "created": {
            "title": "Created",
            "message": "Purchase order has been created.",
            "link": "View purchase order"
        },
        "createdAndSubmitted": {
            "title": "Created",
            "message": "Purchase order has been created. Waiting for approval now. ",
            "link": "View purchase order"
        },
        "deleted": {
            "title": "Removed",
            "message": "Purchase order has been removed."
        },
        "rejected": {
            "title": "Rejected",
            "message": "Purchase order has been rejected."
        },
        "submitted": {
            "title": "Waiting for approval",
            "message": "Purchase order awaiting approval."
        },
        "reopened": {
            "title": "Status reset",
            "message": "Purchase order was moved back to fulfillment."
        },
        "updated": {
            "title": "Updated",
            "message": "Purchase order has been updated."
        },
        "summary_exported": {
            "title": "Exported",
            "message": "Purchase order summary has been exported."
        }
    },
    "requester_is_same_as_next_approver": "The requester from the expense #{{expenseNumber}} is the folder's next approver. Update the approver before attaching this expense, or attach it only after review is complete",
    "folder_requester_is_same_as_expense_next_approver": "Expense #{{expenseNumber}} cannot be attached because the requester is also registered as the next approver of the folder. Please change the approver or attach the expense only after the review has been completed. ",
    "delivery_note": {
        "created": {
            "title": "Created",
            "message": "Delivery note has been created.",
            "link": "View delivery note"
        },
        "deleted": {
            "title": "Removed",
            "message": "Delivery note has been removed."
        },
        "updated": {
            "title": "Updated",
            "message": "Delivery note has been updated."
        }
    },
    "window": {
        "popup_opening": {
            "title": "Pop-up opening",
            "message": "The pop-up opens in a new tab. If it doesn’t appear, please allow pop-ups or click here:"
        },
        "popup_blocked": {
            "title": "Pop-up blocked",
            "message": "Please allow pop-ups."
        }
    },
    "table_column_view": {
        "saved": {
            "title": "View saved",
            "message": "Your column view has been saved."
        }
    }
}
